<form id="myForm" (ngSubmit)="onSubmit()" [formGroup]="form" class="vertical-form">
  <div fxFlex="1 1 100%" fxLayout="row" fxFlexFill fxLayoutGap="20px" class="mat-typography">
    <div fxFlex="40%" fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="20px">

      <!-- Staff Campaign -->
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
        <mat-form-field fxFlex style="min-width: 100px;">
          <mat-label>Coin multiplier</mat-label>
          <input type="number" matInput placeholder="" formControlName="coinMultiplier" maxlength="100">
          @if (!form.get('coinMultiplier').valid) {
            <mat-error>Enter coin multiplier</mat-error>
          }
        </mat-form-field>
        <mat-form-field fxFlex style="min-width: 100px;">
          <mat-label>Min score</mat-label>
          <input type="number" matInput placeholder="" formControlName="minScore">
          @if (!form.get('minScore').valid) {
            <mat-error>Enter min score</mat-error>
          }
        </mat-form-field>
      </div>


      <!-- TimeLimit -->
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
        <mat-form-field fxFlex style="min-width: 100px;">
          <mat-label>Limit number of coins received</mat-label>
          <input matInput type="number" placeholder="" formControlName="timeLimitMaxLimit" step="1" autocomplete="off">
          @if (form.get('timeLimitMaxLimit').errors) {
            <mat-error>Field required</mat-error>
          }
        </mat-form-field>
        <mat-form-field fxFlex style="min-width: 50px;">
          <mat-label>Limit interval ({{ displayDuration(form.value.timeLimitInterval) || 'hh:mm:ss' }})</mat-label>
          <input matInput type="text" placeholder="" formControlName="timeLimitInterval" autocomplete="off">
          @if (form.get('timeLimitInterval').errors?.invalidLimit) {
            <mat-error>Field required</mat-error>
          }
          @if (form.get('timeLimitInterval').errors?.invalidTs) {
            <mat-error>Invalid format ('hh:mm:ss')</mat-error>
          }
        </mat-form-field>
      </div>

      <div fxFlex>
        <app-reward-select #serviceReward [advertiserId]="advertiserId"
          [title]="'Instant win for service event (stamps given)'"></app-reward-select>
      </div>
    </div>

    <div fxFlex>
      <app-consumption-filters-edit #filters></app-consumption-filters-edit>
    </div>
  </div>

</form>